import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import PackService from "../services/packs/packService";
import { GetPacksParams } from "../services/packs/types";
import { UseQueryOptions } from "@tanstack/react-query";
import { PaginatedResponse } from "@/features/profiles/services/profiles/types";
import { IPack } from "../services/packs/types";

export const usePacksData = (
  params: GetPacksParams = {},
  options?: Omit<UseQueryOptions<PaginatedResponse<IPack>>, "queryKey" | "queryFn">
) => {
  return useCustomQuery({
    serviceInstance: PackService.Instance,
    selectAction: (service) => service.getPacks,
    parameter: params,
    options,
  });
};
